import React, { useRef } from 'react';
import './App.css';
import Hero from './components/Hero';
import ServiceOptions from './components/ServiceOptions';
import ReportIssue from './components/ReportIssue';
import GuaranteeSection from './components/GuaranteeSection';
import Footer from './components/Footer';
import { serviceOptions, phoneModels, guaranteeInfo } from './mockData';
import { Toaster } from './components/ui/sonner';
import { toast } from 'sonner';

function App() {
  const reportRef = useRef(null);

  const handleGetStarted = () => {
    reportRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleServiceClick = (service) => {
    toast.success(`${service.title} selected`, {
      description: service.description
    });
  };

  return (
    <div className="App">
      <Hero onGetStarted={handleGetStarted} />
      <ServiceOptions services={serviceOptions} onServiceClick={handleServiceClick} />
      <div ref={reportRef}>
        <ReportIssue phoneModels={phoneModels} />
      </div>
      <GuaranteeSection guaranteeInfo={guaranteeInfo} />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;